import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { showToastSuccess } from '@core/components/toastify/ToastTypes';
import { completeUnitAsync } from 'store/units/index';
import useI18n from 'hooks/use-i18n';
import { useUnit } from 'hooks/units/index';
import { handleToastError } from 'helpers/index';
import { getColor, getColorText } from 'store/settings';
import { getSelectedCentre } from 'store/master';
import { COURSE_STATUS } from 'constants/constants';

const ButtonComplete = () => {
  const i18n = useI18n();
  const { query } = useRouter();
  const dispatch = useDispatch();
  const unitSelected = useUnit();
  const [isLoading, setIsLoading] = useState(false);
  const selectedCentre = useSelector(getSelectedCentre);
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);

  //DisableConditon
  let isDisabled = unitSelected?.status == COURSE_STATUS.INACTIVE;

  const handleCompleteUnit = async () => {
    try {
      let param = {};
      if (selectedCentre?._id) {
        param.centreId = selectedCentre?._id;
      }
      if (
        selectedCentre?.reviewContent ||
        selectedCentre?.reviewContent === undefined
      ) {
        param.reviewContent = true;
      }
      setIsLoading(true);
      await dispatch(
        completeUnitAsync(undefined, unitSelected._id, query?.slug, param),
      );
      showToastSuccess('Lesson completed successfully');
    } catch (e) {
      setIsLoading(false);
      handleToastError(e, i18n);
    }
  };

  return (
    <button
      className="btn-bg-color"
      onClick={() => handleCompleteUnit()}
      disabled={isLoading || isDisabled}
      style={{
        backgroundColor: `${colorStatus}`,
        color: `${colorTextStatus}`,
      }}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = 'white';
        e.target.style.borderColor = colorStatus;
        e.target.style.color = colorStatus;
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = colorStatus;
        e.target.style.color = colorTextStatus;
      }}
    >
      Complete
    </button>
  );
};

export default ButtonComplete;
